import React from 'react';

import icoClose from 'assets/images/close-btn-black.svg';
import icoSuccessful from 'assets/images/dialogs/ChargeSuccessful.svg';
import S from 'constants/string.const';
import { withTranslation } from 'providers/GILT.provider';
import getArray from 'utils/accessors/getArray.util';

import ConfirmationDialog from 'scheduler/components/ConfirmationDialog';
import StylistWithEmail from 'settings/stylists/StylistWithEmail';

import 'styles/settings/pages/pincode-modal-existing-email.scss'; // eslint-disable-line import/first

class PincodeExistingEmailPopup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: true,
      confirmationDialog: false,
      successfulDialog: false,
      userId: -1,
      userEmail: '',
    };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.removedAccess && nextProps.removedAccess) {
      this.setState({ successfulDialog: true });
    }
  }

  // FIXME: check if this duplicate or the following one is the correct
  // noinspection JSUnusedGlobalSymbols
  onSetupPinDuplicate = () => {
    this.props.closePinPopup();
    this.setState({ confirmationDialog: false, showModal: false });
  };

  onSetupPin = () => void this.props.closePopup();

  onRemove = (userId) => {
    this.props.removeAccess(this.props.salonId, userId);
    this.setState({ confirmationDialog: false, showModal: true });
  };

  exit = () => {
    // FIXME: as the main sidebar has been rewritten this selectors no longer exists
    const menuBtn = document.querySelector('.nav-button.closed');
    const mainMenu = document.querySelector('.nav.isClose');

    if (menuBtn) {
      menuBtn.classList.remove('closed');
      menuBtn.classList.add('opened');
    }

    if (mainMenu) {
      mainMenu.classList.remove('isClose');
      mainMenu.classList.add('visible');
      // Guan, issue on this 👆  once menu is opened I can't close it by clicking X icon from nav menu
    }

    this.setState({ showModal: false });
    this.props.closePopup();
    this.props.toggleMenu();
  };

  showRemovePopup = (userId, userEmail) =>
    void this.setState({
      confirmationDialog: true,
      showModal: false,
      userId,
      userEmail,
    });
  cancelRemove = () => void this.setState({ confirmationDialog: false, showModal: true });
  showRemoveAccess = () => void this.setState({ successfulDialog: true, confirmationDialog: false });

  closeSuccessfulDialog = () => {
    this.setState({ successfulDialog: false, confirmationDialog: false, showModal: true });
    this.props.resetRemovedAccess();
  };

  render() {
    const { t } = this.props;
    const { userEmail, userId, confirmationDialog, successfulDialog, showModal } = this.state;
    const emailsWithLogin = getArray('emailsWithLogin', this.props);

    return (
      <div data-bem="PincodeExistingEmailPopup">
        {showModal && (
          <>
            <div className="overlay-existing-email" />
            <div id="modal-existing-email">
              <span className="close-btn" role="button" tabIndex="0" onClick={this.exit}>
                <img src={icoClose} alt="Exit anyway" />
              </span>
              <div className="scroll-area">
                <h2 className="title">{t('composite.sidebarMenu.existingEmailModal.title')}</h2>
                <div className="description">
                  {t('composite.sidebarMenu.existingEmailModal.description.part1')}
                  {S.space}
                  <strong>{t('composite.sidebarMenu.existingEmailModal.description.part2')}</strong>
                  {S.space}
                  {t('composite.sidebarMenu.existingEmailModal.description.part3')}
                  {S.space}
                  <strong>{t('composite.sidebarMenu.existingEmailModal.description.part4')}</strong>
                  {S.space}
                  {t('composite.sidebarMenu.existingEmailModal.description.part5')}
                </div>
                <div className="user-list">
                  <ul>
                    {emailsWithLogin.map(({ id, email }) => (
                      <li data-bem="PincodeExistingEmailPopup__stylist-with-email-container" key={`${id}-${email}`}>
                        <StylistWithEmail id={id} email={email} onSetupPin={this.onSetupPin} onRemove={this.onRemove} showRemovePopup={this.showRemovePopup} />
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="additional-text">
                  <p>{t('composite.sidebarMenu.existingEmailModal.additionalInfo.part1')}</p>
                  <p>{t('composite.sidebarMenu.existingEmailModal.additionalInfo.part2')}</p>
                  <p>{t('composite.sidebarMenu.existingEmailModal.additionalInfo.part3')}</p>
                </div>
              </div>
              <div className="footer-existing-email">
                <button type="button" className="btn btn-violet" onClick={this.exit}>
                  {t('composite.sidebarMenu.existingEmailModal.exitButton')}
                </button>
              </div>
            </div>
          </>
        )}

        {confirmationDialog && (
          <ConfirmationDialog
            onRequestClose={() => {}}
            title=""
            leftButtonText={t('composite.sidebarMenu.confirmationDialog.cancelButton')}
            onLeft={this.cancelRemove}
            rightButtonText={t('composite.sidebarMenu.confirmationDialog.confirmButton')}
            onRight={() => this.onRemove(userId)}
            displayHeader="header-non"
            onCancel={() => {}}
          >
            <h2 className="dialog-inner-title" style={{ marginTop: '0', paddingLeft: '0' }}>
              {t('composite.sidebarMenu.confirmationDialog.title')}
            </h2>
            <strong className="text-bold">{userEmail}</strong>
            {S.space}
            {t('composite.sidebarMenu.confirmationDialog.description')}
            <br />
          </ConfirmationDialog>
        )}

        {successfulDialog && (
          // clicking OK should return them to the popup modal
          // with the email users who don't have pincode
          // (updated to exclude the one which was just removed)

          <ConfirmationDialog
            onRequestClose={() => {}}
            title=""
            leftButtonText=""
            onLeft={() => {}}
            rightButtonText={t('common.buttons.ok')}
            onRight={this.closeSuccessfulDialog}
            displayHeader="header-non"
            onCancel={() => {}}
          >
            <h2 className="dialog-inner-title" style={{ marginTop: '0', paddingLeft: '0' }}>
              {t('composite.sidebarMenu.confirmationDialog.successMsg')}
            </h2>
            <img src={icoSuccessful} alt="Email login access successfully removed" style={{ display: 'block', margin: '0 auto' }} />
            <br />
          </ConfirmationDialog>
        )}
      </div>
    );
  }
}

const PincodeExistingEmailPopupHoc = withTranslation()(PincodeExistingEmailPopup);
export default PincodeExistingEmailPopupHoc;
